import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import { Card, Collapse, Radio } from "@nextui-org/react";
import React, { useState } from "react";
export var ThemePicker = function ThemePicker(_ref) {
  var defaultTheme = _ref.defaultTheme,
      onThemeChange = _ref.onThemeChange,
      themes = _ref.themes;

  var _useState = useState(defaultTheme),
      _useState2 = _slicedToArray(_useState, 2),
      currentTheme = _useState2[0],
      setCurrentTheme = _useState2[1];

  return /*#__PURE__*/React.createElement(Card, null, /*#__PURE__*/React.createElement(Collapse.Group, null, /*#__PURE__*/React.createElement(Collapse, {
    title: "Theme"
  }, /*#__PURE__*/React.createElement(Radio.Group, {
    value: currentTheme
  }, themes.map(function (theme) {
    return /*#__PURE__*/React.createElement(Radio, {
      value: theme.name,
      key: theme.name,
      onChange: function onChange(e) {
        if (e.target.checked) {
          setCurrentTheme(theme.name);
          onThemeChange === null || onThemeChange === void 0 ? void 0 : onThemeChange(theme.name);
        }
      }
    }, theme.displayName);
  })))));
};